module.exports = __webpack_public_path__ + "img/onborad4.e86639bd.png";